const emailRegex = /(.+)@(.+){2,}\.(.+){2,}/;

export const emailUtils = {
  isValid: (email: string) => emailRegex.test(email),
  getHelpEmail: (isMFSupport = false, isSingleFamilyEnterpriseCustomer = false, isSingleFamilyBoost = false) => {
    if (isMFSupport) {
      return 'rentalpartners@zillowgroup.com';
    }
    if (isSingleFamilyEnterpriseCustomer) {
      return 'rentalshelp@zillowgroup.com';
    }
    if (isSingleFamilyBoost) {
      return 'sfrentalsboost@zillowgroup.com';
    }
    return 'rentalsupport@zillow.com';
  },
};
